import './styles.scss';

import CheckIcon from '@mui/icons-material/Check';
import {Box, Typography} from '@mui/material';

import {LetterAvatar} from '@/app/shared-components/LetterAvatar';
import {COLORS} from '@/styles/colors';

export interface Transaction {
  id: string;
  /** Expense name, e.g. "Dinner" or "Brianna Settled up" or "You settled up" */
  title: string;
  /** e.g. "Brianna paid $100.00" or "You paid $100.00" */
  description: string;
  /** Top-right label, e.g. "Your share" */
  rightTop?: string;
  /** Bottom-right value, e.g. "$33.33" */
  rightBottom: string;
  /** Single letter(s) shown in the avatar */
  avatarLabel: string;
  /** When true, a check icon is shown instead of a letter avatar */
  settled?: boolean;
  isOwner?: boolean;
}

export interface ActivityGroup {
  /** Section heading, e.g. "Today", "Yesterday", "Feb 21" */
  title: string;
  transactions: Transaction[];
}

export interface TransactionListProps {
  group: ActivityGroup;
}

export interface TransactionCellProps {
  transaction: Transaction;
}

const TransactionCell: React.FC<TransactionCellProps> = ({transaction}) => (
  <div className="group-dashboard-activities__cell">
    <LetterAvatar
      icon={
        transaction.settled ? (
          <CheckIcon style={{color: COLORS.ON_SURFACE}} />
        ) : undefined
      }
      name={transaction.avatarLabel}
      bgColor={
        transaction.settled
          ? COLORS.BACKGROUND_LIGHT
          : transaction.isOwner
            ? COLORS.BACKGROUND_AVATAR_BLUE
            : COLORS.BACKGROUND_DEFAULT
      }
      textColor={transaction.isOwner ? COLORS.INFO_BLUE : undefined}
      size={40}
    />

    <div className="group-dashboard-activities__main">
      <span className="group-dashboard-activities__main-title">
        {transaction.title}
      </span>
      <span className="group-dashboard-activities__main-description">
        {transaction.description}
      </span>
    </div>

    <Box
      className="group-dashboard-activities__right"
      sx={{
        justifyContent: transaction.settled ? 'center' : 'space-between',
      }}>
      {transaction.rightTop && (
        <div className="group-dashboard-activities__right-top">
          {transaction.rightTop}
        </div>
      )}
      <Box className="group-dashboard-activities__right-bottom">
        <Typography
          sx={{
            color: transaction.settled
              ? COLORS.ON_SURFACE
              : COLORS.ON_SURFACE_VARIANT,
          }}>
          {transaction.rightBottom}
        </Typography>
      </Box>
    </Box>
  </div>
);

export const TransactionList: React.FC<TransactionListProps> = ({group}) => (
  <div className="group-dashboard-activities__list">
    <span className="group-dashboard-activities__list-title">
      {group.title}
    </span>

    <div className="group-dashboard-activities__list-cells">
      {group.transactions.map(tx => (
        <TransactionCell
          key={tx.id}
          transaction={tx}
        />
      ))}
    </div>
  </div>
);
